<template>
  <div class="fixed top-4 right-4 z-[9999] pointer-events-none">
    <transition name="toast">
      <div v-show="open" role="alert" class="pointer-events-auto">
        <div class="inline-flex min-w-80 px-4 py-2 rounded-lg text-sm text-white" :class="typeColor(type)">
          <div class="flex w-full justify-between items-start gap-3">
            <div class="flex min-w-0 flex-1 items-start gap-3">
              <span
                v-if="type === 'warning'"
                class="toast-status toast-status--warning"
                aria-hidden="true"
              >!</span>
              <span
                v-else-if="type === 'error'"
                class="toast-status toast-status--error"
                aria-hidden="true"
              >!</span>
              <svg
                v-else-if="type === 'success'"
                class="toast-icon shrink-0 fill-current opacity-90 mt-[2px]"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                aria-hidden="true"
              >
                <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z" />
              </svg>
              <svg
                v-else
                class="toast-icon shrink-0 fill-current opacity-90 mt-[2px]"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                aria-hidden="true"
              >
                <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
              </svg>
              <div class="font-medium min-w-0 pt-[1px]">
                {{ message }}
              </div>
            </div>
            <button
              class="toast-close shrink-0"
              type="button"
              aria-label="Close notification"
              @click="open = false"
            >
              <svg class="fill-current" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "notify",
  data() {
    return{
      message: '',
      type: 'success',
      timer: 3000,
      open: false,
      timeoutId: null,
    }
  },
  methods:{
    typeColor(type) {
      switch (type) {
        case 'warning':
          return 'bg-yellow-500'
        case 'error':
          return 'bg-red-500'
        case 'success':
          return 'bg-green-500'
        default:
          return 'bg-violet-500'
      }
    },
    show(data) {
      const nextMessage = data && typeof data.message === 'string' ? data.message : 'missing "message".'
      const nextType = data && typeof data.type === 'string' ? data.type : 'success'
      const nextTimer = data && Number.isFinite(Number(data.timer)) ? Number(data.timer) : 3000

      this.message = nextMessage
      this.type = nextType
      this.timer = nextTimer
      this.open = true

      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
      }
      if (this.timer > 0) {
        this.timeoutId = setTimeout(() => {
          this.open = false
          this.timeoutId = null
        }, this.timer)
      }
    }
  },
  beforeDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  },
}
</script>

<style scoped>
.toast-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  margin-top: 2px;
  flex-shrink: 0;
  border-radius: 9999px;
  border: 1.5px solid currentColor;
  font-size: 0.6875rem;
  font-weight: 800;
  line-height: 1;
}

.toast-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-top: 3px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  opacity: 0.75;
  cursor: pointer;
}

.toast-close:hover {
  opacity: 1;
}

.toast-close:focus {
  outline: none;
}

.toast-close:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.85);
  outline-offset: 2px;
  border-radius: 4px;
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 150ms ease, transform 150ms ease;
}
.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
